import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import appInsights, { setUserContext } from "./appInsights";
import { useMsal } from "@azure/msal-react";
const PageTracker = ({ user }) => {
  const location = useLocation();

  const { accounts } = useMsal();
  const activeAccount = accounts[0];
  useEffect(() => {
    if (activeAccount) {
      setUserContext(activeAccount);
    }
  }, [activeAccount]);
  useEffect(() => {
    const readableId =
      activeAccount?.idTokenClaims?.preferred_username ||
      activeAccount?.username;
    if (readableId) {
      appInsights.trackPageView({
        name: location.pathname,
        uri: window.location.href,
        properties: { userId: readableId }, // now email/UPN
      });
    }
  }, [location, activeAccount]);
  return null;
};
export default PageTracker;